module.exports = __webpack_public_path__ + "img/TK.c351da0f.svg";